// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"536":"204e8195","560":"c1296dae","604":"03d2a141","952":"f2f8eae9"}[chunkId] + ".css";
};